import { makeStyles } from '@material-ui/core';

const modalGraficoStyles = makeStyles(() => ({
  SimpleDialogRoot: {
    zIndex: '1050 !important',
    width: '100%',
  },
  SimpleDialogContainer: {
    padding: 16,
    display: 'flex',
  },
  SimpleDialogPaper: {
    margin: 0,
    flex: '1 1 auto',
  },
  SimpleDialogPaperFullScreen: {
    borderRadius: '8px !important',
  },
  SimpleDialogPaperScrollPaper: {
    maxHeight: '100%',
  },
  SimpleDialogContentRoot: {
    padding: 0,
    margin: 0,
    '&:first-child': {
      paddingTop: 0,
    },
  },
  paperWidthSm: {
    maxWidth: '100%',
    position: 'absolute',
    top: 32,
  },
  IndicadoresContas: {
    margin: '46px 0px',
    width: 288,
    height: 25,
    opacity: 0.84,
    fontFamily: 'Muli',
    fontSize: 20,
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 0.6,
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#233d4d',
  },
  textFooter: {
    width: 790,
    height: 19,
    opacity: 0.84,
    fontFamily: 'Muli',
    fontSize: 15,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.3,
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#233d4d',
  },
}));

export default modalGraficoStyles;
